import React, { Component } from "react";
import { debounce } from "throttle-debounce";

import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withMapPositions } from "../../../shared/containers/containerMapPositions";
import { withMessages } from "../../../shared/containers/containerMessages";
import { withIntelligenceTimeRangePlayer } from "../../../shared/containers/containerIntelligenceTimeRangePlayer";
import DropDown from "../../../shared/items/contols/dropDown";
import IntelegancePayerSpeedItemControl from "./intelegancePayerSpeedItemControl";
import { v4 as uuidv4 } from "uuid";

import Slider from "@material-ui/core/Slider";
import ButtonControls from "../../../shared/items/contols/buttonControls";
import IntelligenceSensorItem from "./intelligenceSensorItem";
import CarStatusTitle from "../../../shared/items/static/carStatusTitle";
import Notification from "../../../shared/items/static/notification";
import Preloader from "../../../shared/items/static/preloader";
import TooltipWrapper from "./../../../shared/items/contols/tooltipWrapper";

import getDates from "../../../shared/services/date.service";
import messages from "../../../shared/static.messages";
import { states } from "../../../reducers/queriesStates";

import "./intelligencePlayer.scss";
import styles from "./intelligencePlayer.module.scss";
import variables from "./../../../values.scss";
import { withMapControl } from "../../../shared/containers/containerMapControl";

var playerTimeOut;
var playerSpeed = parseFloat(variables.playerSpeed) * 500;

class IntelligencePlayerData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playerValue: 0,
      isLoaded: false,
      speedControlIsOpen: false,
      speedDevider: 1,
    };

    this.handleSetStatePlayerValue = this.handleSetStatePlayerValue.bind(this);
    this.handleSetCurrentPoint = debounce(50, this.props.onSetCurrentPoint.bind(this));
  }

  componentDidMount() {
    const { currentPointIndex, messagesDataState, onGetMessages, carId, startDate, endDate } = this.props;

    if (messagesDataState !== states.READY) {
      onGetMessages({
        carId,
        startDate,
        endDate,
      });
    } else {
      this.setState({ isLoaded: true });
    }

    if (!!currentPointIndex) this.setState({ playerValue: currentPointIndex });
  }

  componentDidUpdate(prevProps, prevState) {
    const { mapPositionsDataState, mapPositionsData, isPlay, currentPointIndex, messagesDataState } = this.props;

    if (prevProps.messagesDataState === states.REQUEST && messagesDataState === states.READY) {
      this.setState({ isLoaded: true });
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.REQUEST) {
      if (currentPointIndex !== 0) {
        this.handleSetCurrentPoint(0, mapPositionsData[0].time);
      }
    }

    if (prevProps.currentPointIndex !== currentPointIndex && !isPlay) this.handleSetStatePlayerValue(currentPointIndex);

    if (prevProps.currentPointIndex < currentPointIndex && isPlay) {
      const { speedDevider } = this.state;
      playerTimeOut = setTimeout(() => this.setNextPlayerPoint(), playerSpeed / speedDevider);
    }

    if (prevProps.currentPointIndex !== currentPointIndex && currentPointIndex === 0 && isPlay) {
      this.handlePause();
    }

    if (prevProps.isPlay !== isPlay && isPlay) {
      this.setNextPlayerPoint();
    }

    if (!isPlay && prevState.playerValue !== this.state.playerValue && mapPositionsData.length > 0) {
      this.handleSetCurrentPoint(this.state.playerValue, mapPositionsData[this.state.playerValue].time);
    }
  }

  componentWillUnmount() {
    this.handleSetStatePlayerValue(0);
  }

  handleSetStatePlayerValue(value) {
    clearInterval(playerTimeOut);
    this.setState({ playerValue: value });
  }

  handlePlay() {
    const { mapPositionsCount, onPlayRoute, currentPointIndex, onSetMapBounds } = this.props;

    onSetMapBounds(null);
    if (currentPointIndex < mapPositionsCount - 1) onPlayRoute();
  }

  handlePause() {
    const { onPauseRoute, currentPointIndex } = this.props;

    clearInterval(playerTimeOut);
    this.handleSetStatePlayerValue(currentPointIndex);
    onPauseRoute();
  }

  handleStop() {
    const { onSetCurrentPoint, currentPointIndex } = this.props;

    if (currentPointIndex !== 0) {
      clearInterval(playerTimeOut);
      onSetCurrentPoint(0, null);
      this.handleSetStatePlayerValue(0);
    }
  }

  setNextPlayerPoint() {
    const { mapPositionsCount, mapPositionsData, onSetCurrentPoint, currentPointIndex } = this.props;
    let nextPointIndex = currentPointIndex + 1;

    nextPointIndex <= mapPositionsCount - 1 ? onSetCurrentPoint(nextPointIndex, mapPositionsData[nextPointIndex].time) : this.handlePause();
  }

  setPrevPoint() {
    let prevPointIndex = this.state.playerValue - 1;

    if (prevPointIndex >= 0) {
      this.handleSetStatePlayerValue(prevPointIndex);
    }
  }

  setNextPoint() {
    const { mapPositionsCount } = this.props;
    let nextPointIndex = this.state.playerValue + 1;

    if (nextPointIndex <= mapPositionsCount - 1) this.handleSetStatePlayerValue(nextPointIndex);
  }

  handelChangePlayer(event, value) {
    const { mapPositionsData, onSetCurrentPoint, onPauseRoute, isPlay } = this.props;

    if (isPlay) onPauseRoute();

    onSetCurrentPoint(value, mapPositionsData[value].time);
  }

  componentWillUnmount() {
    const { isPlay, onPauseRoute } = this.props;

    if (isPlay) onPauseRoute();
  }

  getMessage(time) {
    const { messagesData } = this.props;
    const date = new Date(time);
    let count = 0;

    messagesData.forEach((message) => {
      if (date > new Date(message.time)) {
        count++;
      } else {
        return;
      }
    });

    return messagesData[count];
  }

  render() {
    const { isLoaded } = this.state;
    const { mapPositionsDataState, mapPositionsCount, mapPositionsData, isPlay, currentPointIndex } = this.props;
    const playerValue = isPlay ? currentPointIndex : this.state.playerValue;
    const currentPoint = mapPositionsCount > 0 ? mapPositionsData[currentPointIndex] : null;

    if (!isLoaded) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    if (currentPoint === null || currentPoint === undefined) return null;

    const message = this.getMessage(currentPoint.time);
    if (message === undefined) {
      return null;
    }

    const onSetSpeedPlayer = (speedDevider) => {
      this.setState({ speedControlIsOpen: false, speedDevider });
    };

    return (
      <div className={styles.intellegenceTimeRangePlayer}>
        {mapPositionsDataState === states.READY && mapPositionsCount > 0 ? (
          <React.Fragment>
            <div className="slider_container">
              <Slider
                step={1}
                min={0}
                max={mapPositionsCount !== 0 ? mapPositionsCount - 1 : 1}
                value={playerValue}
                onChange={
                  mapPositionsCount > 0
                    ? (event, value) => {
                        this.handleSetStatePlayerValue(value);
                      }
                    : null
                }
                onChangeCommitted={mapPositionsCount > 0 ? this.handelChangePlayer.bind(this) : null}
              />
            </div>
            <div className={styles.controls_container}>
              <div className={styles.date_container}>
                <span className={styles.currentPointDate}>{mapPositionsCount > 0 ? getDates.getDateFormat3(currentPoint.time) : null}</span>
              </div>
              <div className={styles.buttons_container}>
                <div className={styles.button_container}>
                  <TooltipWrapper title="Назад" position="top">
                    <div>
                      <ButtonControls
                        icon="backward"
                        handleClick={this.setPrevPoint.bind(this)}
                        disabled={isPlay || mapPositionsCount === 0 || currentPointIndex === 0}
                      />
                    </div>
                  </TooltipWrapper>
                </div>
                {isPlay || currentPointIndex === mapPositionsCount - 1 ? (
                  <div className={styles.button_container}>
                    <TooltipWrapper title="Стоп" position="top">
                      <div>
                        <ButtonControls icon="stop" handleClick={this.handleStop.bind(this)} />
                      </div>
                    </TooltipWrapper>
                  </div>
                ) : (
                  <div className={styles.button_container}>
                    <TooltipWrapper title="Проиграть" position="top">
                      <div>
                        <ButtonControls
                          icon="play"
                          handleClick={this.handlePlay.bind(this)}
                          disabled={mapPositionsCount === 0 && !isPlay}
                        />
                      </div>
                    </TooltipWrapper>
                  </div>
                )}
                <div className={styles.button_container}>
                  <TooltipWrapper title="Пауза" position="top">
                    <div>
                      <ButtonControls icon="pause" handleClick={this.handlePause.bind(this)} disabled={!isPlay} />
                    </div>
                  </TooltipWrapper>
                </div>
                <div className={styles.button_container}>
                  <TooltipWrapper title="Вперед" position="top">
                    <div>
                      <ButtonControls
                        icon="forward"
                        handleClick={this.setNextPoint.bind(this)}
                        disabled={isPlay || mapPositionsCount === 0 || currentPointIndex === mapPositionsCount - 1}
                      />
                    </div>
                  </TooltipWrapper>
                </div>
                <div className={styles.button_container_speed_control}>
                  <DropDown
                    key={uuidv4()}
                    isOpen={this.state.speedControlIsOpen}
                    button={<div>Скорость проигрывания: x{this.state.speedDevider}</div>}
                    content={
                      <>
                        <IntelegancePayerSpeedItemControl value={"0.25"} handleClick={onSetSpeedPlayer} speedDevider={0.25} />
                        <IntelegancePayerSpeedItemControl value={"0.5"} handleClick={onSetSpeedPlayer} speedDevider={0.5} />
                        <IntelegancePayerSpeedItemControl value={"1"} handleClick={onSetSpeedPlayer} speedDevider={1} />
                        <IntelegancePayerSpeedItemControl value={"2"} handleClick={onSetSpeedPlayer} speedDevider={2} />
                        <IntelegancePayerSpeedItemControl value={"4"} handleClick={onSetSpeedPlayer} speedDevider={4} />
                      </>
                    }da
                  />
                </div>
              </div>
            </div>
            <div className={styles.pointInfo_container}>
              <div className={styles.pointInfoList}>
                <div className={styles.pointInfoItem_container}>
                  <IntelligenceSensorItem title="Статус" value={<CarStatusTitle status={Number(message.data["USTA"])} />} />
                </div>
                <div className={styles.pointInfoItem_container}>
                  <IntelligenceSensorItem title="Скорость" value={`${Number(message.data["SPEE"])}`} mesure={" км/ч"} />
                </div>
                <div className={styles.pointInfoItem_container}>
                  <IntelligenceSensorItem title="Адрес" value={message.data["ADD"]} />
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : mapPositionsDataState === states.READY && mapPositionsCount === 0 ? (
          <Notification type="warning">
            <p>{messages.noData}</p>
          </Notification>
        ) : mapPositionsDataState === states.FAILURE ? (
          <Notification type="error">
            <p>{messages.error}</p>
          </Notification>
        ) : mapPositionsDataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <Preloader />
          </div>
        ) : null}
      </div>
    );
  }
}
export default withMapControl(
  withIntelligenceTimeRangePlayer(withMessages(withMapPositions(withTimerangeIntelligence(IntelligencePlayerData))))
);
